import { ScaleLinear as d3ScaleLinear, ScaleTime as d3ScaleTime, ScalePoint as d3ScalePoint } from 'd3';
import { Theme, ValueOf } from '@redsift/design-system';
import { BarDatum } from '../../types';
import { DataPointProps, StyledDataPointProps } from '../DataPoint';

/**
 * Component variant.
 */
export const BarOrientation = {
  horizontal: 'horizontal',
  vertical: 'vertical',
};
export type BarOrientation = ValueOf<typeof BarOrientation>;

export const BarDirection = {
  up: 'up',
  down: 'down',
};
export type BarDirection = ValueOf<typeof BarDirection>;

/**
 * Component props.
 */
export interface BarProps extends DataPointProps<BarDatum> {
  /**
   * Gap between two siblings.
   * @default 5
   */
  gap?: number;
  /**
   * Height of the bar in horizontal orientation.
   * @default 40
   */
  height?: number;
  /** Maximum height of the bar. */
  maxHeight?: number;
  /**
   * Orientation of the bar.
   * @default 'vertical'
   */
  orientation?: BarOrientation;
  /** Direction of the bar, works only with vertical orientation. */
  direction?: BarOrientation;
  /** A linear continuous scale defined over a numeric domain used to determine the width or height of the bar (depending on the orientation). */
  scale: d3ScaleLinear<number, number, never>;
  /** A scale defined over a numeric/time/ordinal domain used to determine the position of the bar. */
  scalePosition: d3ScaleLinear<number, number, never> | d3ScaleTime<number, number, never> | d3ScalePoint<string>;
  /**
   * Width of the bar in vertical orientation.
   * @default 40
   */
  width?: number;
  /** Min width of the bar in vertical orientation. */
  minWidth?: number;
}

export type StyledBarProps = StyledDataPointProps &
  Omit<BarProps, 'scale' | 'scalePosition'> & {
    $theme: Theme;
  };
